import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../routes";
import Button from "../../Button/Button";
import OTP from "../../Formik/OTP/OTP";
import Modal from "../Modal/Modal";
import styles from "./AddPinModal.module.scss";
import { generateOTPAction } from "../../../../features/user/userSlice";
import { SERVICES, SERVICESTYPE } from "../../../../utils/constants";
import emailStyles from "../../../../components/pages/OnboardScreens/EmailVerification/EmailVerification.module.scss";

const AddPinModal = ({ show, handleClose, donotLink, onSubmitAction, title, cardData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [seconds, setSeconds] = useState();
  const [timer, setTimer] = useState(60);
  const [showBtn, setShowBtn] = useState(false);
  const userData = useSelector((state) => state?.persist?.userInfo);

  const formik = useFormik({
    initialValues: {
      physicalLast4: "",
      otp: "",
    },
    onSubmit: (values) => {
      onSubmitAction(values, formik);
    },
  });


  useEffect(() => {
    if (!show) {
      formik.resetForm();
    }
  }, [show]);

  const generateOTP = async () => {
    const data = {
      username: await userData?.email,
      type: SERVICESTYPE?.EMAIL,
      service: title === "Freeze Card" ? "CARD_LOCK" : "CARD_ACTIVATE",
    };
    try {
      const response = await dispatch(generateOTPAction(data));
      if (response?.status === 200) {
        reSetTime();
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  const setTime = () => {
    if (!seconds || seconds > 0) {
      const timer = setInterval(() => {
        setSeconds((second) => {
          if (second <= 0) {
            return clearInterval(timer);
          }
          return second - 1;
        });
      }, 1000);
    }
  };

  const reSetTime = () => {
    setSeconds(180); // 3 minutes in seconds
    setTime();
  };

  const handleResend = () => {
    formik.setFieldValue("otp", "");
    generateOTP();
    setTimer(56);  // reset timer
    setShowBtn(false);
  };



  useEffect(() => {
    let interval;

    if (timer > 0) {
      setShowBtn(false);
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setShowBtn(true);
    }

    return () => clearInterval(interval);
  }, [timer]);

  return (
    <Modal
      show={show}
      handleClose={handleClose}
      title={title}
      // hideCloseBtn
      className={styles.add_pin_modal}
    >
      {/* Wrap everything inside Formik form */}
      <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
        {/* ONLY FOR PHYSICAL CARD */}
        {cardData?.card_form === "PHYSICAL" && cardData?.status !== "active" &&
          < OTP
            label="Last 4 digits of Physical Card"
            name="physicalLast4"
            numInputs={4}
            value={formik.values.physicalLast4}
            onChange={(value) => { formik.setFieldValue("physicalLast4", value); }}
            onBlur={formik.handleBlur}
            formik={formik}
            placeholder="----"
          />
        }
        <OTP
          label="Enter OTP"
          name="otp"
          value={formik.values.otp}
          onChange={(value) => {
            formik.setFieldValue("otp", value);
          }}
          // onChange={(value) => setOtpValue(value)}
          onBlur={formik.handleBlur}
          formik={formik}
          placeholder="------"
        />
        <div className={emailStyles.btn_restotp}>
          {showBtn ? (
            <Button
              className={` ${emailStyles.restBtn}`}
              onClick={handleResend}
              type="button"
              variant="without_bg_border"
            >
              Re send
            </Button>
          ) : (
            <p>Re send verification code in {timer}s</p>
          )}
        </div>
        <Button
          fluid
          className={styles.btn_pin}
          type="button"
          onClick={(e) => {
            formik.handleSubmit(e);
          }}
        >
          Continue
        </Button>
      </form>
    </Modal>
  );
};

export default AddPinModal;
